import { AxiosError } from 'axios';
import { IResponseError } from '../interfaces/IResponseError';

export class ErrorHelper {
    public static getFieldErrors(e: IResponseError): Record<string, string> {
        const data = e.response?.data;
        if (!data || typeof data !== 'object') {
            return {};
        }

        const fieldErrors: Record<string, string> = {};
        Object.entries(data).forEach(([key, value]) => {
            if (key === 'message') {
                return;
            }
            if (typeof value === 'string') {
                fieldErrors[key] = value;
            }
        });

        if (Object.keys(fieldErrors).length > 0) {
            return fieldErrors;
        }

        if (typeof data.message === 'string') {
            return { global: data.message };
        }

        if (Array.isArray(data.message) && data.message.length > 0) {
            return { global: data.message.join(', ') };
        }

        return {};
    }

    public static getMessage(e: IResponseError) {
        const fieldErrors = this.getFieldErrors(e);
        if (fieldErrors.global) {
            return fieldErrors.global;
        }

        return e.message || 'An unexpected error occurred.';
    }

    public static getErrorForControl(e: Error) {
        const axiosError = e as AxiosError<Record<string, string>>;
        if (axiosError && axiosError.response && axiosError.response.data) {
            if (!axiosError.response.data.message) {
                return axiosError.response.data;
            }
        }
        return {
            global: 'Storage could not be created successfully. ' + this.getMessage(e as IResponseError)
        };
    }
}
